import { createAction } from 'redux-actions';

export const GetSettingLanguageRequested = createAction('GET_SETTING_LANGUAGE_REQUESTED');
export const GetSettingLanguageReceived = createAction('GET_SETTING_LANGUAGE_RECEIVED');
export const GetSettingLanguageFailure = createAction('GET_SETTING_LANGUAGE_FAILURE');
export const GetSettingLanguageInit = createAction('GET_SETTING_LANGUAGE_INIT');

export const UpdateSettingLanguageRequested = createAction('UPDATE_SETTING_LANGUAGE_REQUESTED');
export const UpdateSettingLanguageReceived = createAction('UPDATE_SETTING_LANGUAGE_RECEIVED');
export const UpdateSettingLanguageFailure = createAction('UPDATE_SETTING_LANGUAGE_FAILURE');
export const UpdateSettingLanguageInit = createAction('UPDATE_SETTING_LANGUAGE_INIT');
